<template lang="html">
  <div class="container-pad">
    <rare-home-products-hemisphere :isHeader="true" @jumpToForm="jumpToForm" />

    <home-products-hemisphere-media-row />

    <rare-call-out-box
      CallOutTitle="available for:<br/>&nbsp;&nbsp;Law&nbsp;&nbsp;|&nbsp;&nbsp;Finance&nbsp;&nbsp;|&nbsp;&nbsp;Schools&nbsp;&nbsp;|&nbsp;&nbsp;General"
      CallOutColor="grey"
      padding-x="0%"
    />

    <rare-person-quote
      :quoteTitle="''"
      :quoteBody="'This product is non-confrontational, inclusive and drives self-directed learning to address personal bias. As part of a raft of measures, Hemisphere clearly helps create a more inclusive environment.'"
      :quoteBodySmall="'This product is non-confrontational, inclusive and drives self-directed learning to address personal bias. As part of a raft of measures, Hemisphere clearly helps create a more inclusive environment.'"
      :quoteName="'Lloyd Stephenson'"
      :quotePosition="'Global Director of Recruitment'"
      :quoteLogoImage="'BCLP'"
      :quotePortraightImage="'LloydStephenson'"
      :quoteImageSide="'left'"
    />

    <home-products-hemisphere-main-section />

    <rare-home-products-hemisphere-banner />

    <rare-contact-form :product="'Hemisphere'" :showphone="true" />

    <rare-awards/>
  </div>
</template>

<script>

import HomeProductsHemisphereMediaRow from './components//HomeProductsHemisphereMediaRow';
import RareCallOutBox from '../../../components/commonSections/RareCallOutBox';
import RarePersonQuote from '../../../components/commonSections/RarePersonQuote';
import RareContactForm from '../../../components/forms/RareContactForm';
import RareAwards from '../../../components/carousels/awardsCarousel';

import RareHomeProductsHemisphere from '../components/RareHomeProductsHemisphere';
import homeProductsHemisphereMainSection from './components/homeProductsHemisphereMainSection';
import RareHomeProductsHemisphereBanner from './components/RareHomeProductsHemisphereBanner';

export default {
  name: 'HomeProductsHemisphere',
  props: {
  },
  components: {
    'home-products-hemisphere-media-row': HomeProductsHemisphereMediaRow,
    'rare-call-out-box': RareCallOutBox,
    'rare-person-quote': RarePersonQuote,
    'rare-home-products-hemisphere': RareHomeProductsHemisphere,
    'home-products-hemisphere-main-section': homeProductsHemisphereMainSection,
    'rare-contact-form': RareContactForm,
    'rare-awards': RareAwards,
    'rare-home-products-hemisphere-banner': RareHomeProductsHemisphereBanner,
  },
  data() {
    return {
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    jumpToForm() {
      const element = document.getElementById('rare-contact-form');
      const y = element.getBoundingClientRect().top + (window.pageYOffset - 330);

      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 === true) {
        document.getElementById('validationAnchor').scrollIntoView();
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container-pad {
  padding-top: 20px;
}

@media only screen and (max-width: 800px)  {
  .container-pad {
    padding-top: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsHemisphere/homeProductsHemisphere.vue